import axios from 'axios'

const axiosInstance = axios.create({
    baseURL: '/services/plugin-live-multi-company/perspective',
    headers: {
        'Access-Control-Allow-Origin': '*'
    }
})

const listPerspectivesApi = companyID => {
    return axiosInstance.get('', { params: { companyID } })
}

const createPesrpectiveApi = perspective => {
    return axiosInstance.post('', perspective)
}

const updatePesrpectiveApi = perspective => {
    return axiosInstance.put(`/${perspective.id}`, perspective)
}

export { listPerspectivesApi, createPesrpectiveApi, updatePesrpectiveApi }
